import { render, staticRenderFns } from "./ManageMessage.vue?vue&type=template&id=e035cf40&scoped=true&"
import script from "./ManageMessage.vue?vue&type=script&lang=js&"
export * from "./ManageMessage.vue?vue&type=script&lang=js&"
import style0 from "./ManageMessage.vue?vue&type=style&index=0&id=e035cf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e035cf40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardSubtitle,VContainer,VTab,VTabItem,VTabs})
